import BaseModel from './BaseModel';
import CompanyModel from './CompanyModel';

export default class PolicyholderTemplateActivityModel extends BaseModel {
  init(data) {
    this.id = data.id || 0;
    this.name = data.name || '';
    this.created = data.created ? new Date(data.created) : null;
    this.updated = data.updated ? new Date(data.updated) : null;
    this.company = data.company ? new CompanyModel(data.company) : null;
    this.category = data.category || {};
    this.template_added_count = data.template_added_count || 0;
    this.completed_task_count = data.completed_task_count || 0;
  }

  get categoryName() {
    return this.category.name;
  }

  get createdBy() {
    return this.company.name;
  }
}
